import React from 'react';
import type { BombiixIconProps } from './types';

/** Bombiix Critical Path icon. */
const CriticalPathIcon: React.FC<BombiixIconProps> = ({ size = 20, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" {...rest}>
    <path
      d="M9 9H10.5859C12.7951 9 14.5859 10.7909 14.5859 13V14M14.5859 14H22.5859M14.5859 14V15C14.5859 17.2091 12.7951 19 10.5859 19H9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M22 11.5003L23.7929 13.2932C24.1834 13.6837 24.1834 14.3169 23.7929 14.7074L22 16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    <path
      d="M9 9C9 10.3807 7.88071 11.5 6.5 11.5C5.11929 11.5 4 10.3807 4 9C4 7.61929 5.11929 6.5 6.5 6.5C7.88071 6.5 9 7.61929 9 9ZM5.25 9C5.25 9.69036 5.80964 10.25 6.5 10.25C7.19036 10.25 7.75 9.69036 7.75 9C7.75 8.30964 7.19036 7.75 6.5 7.75C5.80964 7.75 5.25 8.30964 5.25 9Z"
      fill="currentColor"
    />
    <path
      d="M9 18.9492C9 20.3299 7.88071 21.4492 6.5 21.4492C5.11929 21.4492 4 20.3299 4 18.9492C4 17.5685 5.11929 16.4492 6.5 16.4492C7.88071 16.4492 9 17.5685 9 18.9492ZM5.25 18.9492C5.25 19.6396 5.80964 20.1992 6.5 20.1992C7.19036 20.1992 7.75 19.6396 7.75 18.9492C7.75 18.2589 7.19036 17.6992 6.5 17.6992C5.80964 17.6992 5.25 18.2589 5.25 18.9492Z"
      fill="currentColor"
    />
  </svg>
);

export default CriticalPathIcon;
